<template>
  <div id="app">
    <div id="vr"></div>
    <div id="logo">
      <h2>昌黎县兴民伟业建筑设备有限公司</h2>
      <h3>
        <i class="el-icon-location-information"></i> 中国·河北·秦皇岛·昌黎县
      </h3>
      <h5>
        <a href="http://www.xmwy.cn">返回官网</a>
      </h5>
    </div>
    <div id="ts">
      <i
        class="el-icon-arrow-left"
        style="left: 0px"
        v-on:click="arrow_click('pre')"
      ></i>
      <i
        class="el-icon-arrow-right"
        style="right: 0px"
        v-on:click="arrow_click('next')"
      ></i>
      <div class="tc" ref="tc">
        <div class="to" ref="to">
          <span
            class="ti"
            :class="{ active: iv == selectedVR }"
            v-for="iv in vr"
            v-on:click="ti_click(iv)"
          >
            <img :src="iv.thumbnail" />
            <span>{{ iv.name }}</span>
          </span>
        </div>
      </div>
      <div>
        <el-image-viewer
          v-if="isShowMarkerImg"
          :on-close="closeMarkerImg"
          :url-list="markerImgList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Viewer } from "photo-sphere-viewer";
import "photo-sphere-viewer/dist/photo-sphere-viewer.css";
import { MarkersPlugin } from "photo-sphere-viewer/dist/plugins/markers";
import "photo-sphere-viewer/dist/plugins/markers.css";

export default {
  name: "App",
  components: {
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer.vue"),
  },
  data() {
    return {
      markersPlugin: null,
      viewer: null,
      selectedVR: null,
      isShowMarkerImg: false,
      markerImgList: [],
      vr: [
        {
          id: "dm",
          name: "西厂区大门",
          image: require("../src/assets/images/vr/xcdm.jpg"),
          thumbnail: require("../src/assets/images/vr/thumbnail/xcdm.jpg"),
          defaultLat: -0.012242204786357958,
          defaultLong: 5.0290312804410515,
          defaultZoomLvl: 0,
          markers: [
            {
              id: "gc",
              tooltip: "前往西厂区广场",
              type: 0, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              width: 42,
              height: 42,
              latitude: -0.0068405251354637375,
              longitude: 5.331630728915116,
            },
          ],
        },
        {
          id: "gc",
          name: "西厂区广场",
          image: require("../src/assets/images/vr/xcgc.jpg"),
          thumbnail: require("../src/assets/images/vr/thumbnail/xcgc.jpg"),
          defaultLat: -0.055932626000640084,
          defaultLong: 3.8952046828314195,
          markers: [
            {
              id: "bgl1",
              tooltip: "前往办公楼1楼",
              type: 0, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              width: 42,
              height: 42,
              latitude: 0.0020894431289470994,
              longitude: 3.3983498479508323,
            },
            {
              id: "ybj",
              tooltip: "前往样板间",
              type: 0, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              width: 42,
              height: 42,
              latitude: -0.00015295354547117945,
              longitude: 3.915474895614775,
            },
          ],
        },
        {
          id: "ybj",
          name: "样板间",
          image: require("../src/assets/images/vr/ybj.jpg"),
          thumbnail: require("../src/assets/images/vr/thumbnail/ybj.jpg"),
          defaultLat: 0.02876995231790569,
          defaultLong: 3.040930563418639,
          markers: [
            {
              id: "ybj-pk",
              tooltip: "展示盘扣",
              type: 1, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              showProductImgList: [
                require("../src/assets/images/product/pk1.jpg"),
                require("../src/assets/images/product/pk2.jpg"),
              ],
              width: 42,
              height: 42,
              latitude: 0.0434640509910349,
              longitude: 2.916805068176932,
            },
            {
              id: "ybj-lk",
              tooltip: "展示轮扣",
              type: 1, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              showProductImgList: [
                require("../src/assets/images/product/lk1.jpg"),
                require("../src/assets/images/product/lk2.jpg"),
              ],
              width: 42,
              height: 42,
              latitude: 0.003428809828373902,
              longitude: 3.9362657602451545,
            },
            {
              id: "ybj-db",
              tooltip: "展示顶板支撑体系",
              type: 1, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              showProductImgList: [
                require("../src/assets/images/product/db1.jpg"),
                require("../src/assets/images/product/db2.jpg"),
              ],
              width: 42,
              height: 42,
              latitude: -0.0858109250535104,
              longitude: 6.096828539727884,
            },
            {
              id: "ybj-jlq",
              tooltip: "展示剪力墙木模支撑体系",
              type: 1, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              showProductImgList: [
                require("../src/assets/images/product/mm1.jpg"),
                require("../src/assets/images/product/mm2.jpg"),
                require("../src/assets/images/product/mm3.jpg"),
                require("../src/assets/images/product/mm4.jpg"),
              ],
              width: 42,
              height: 42,
              latitude: -0.12937205931231732,
              longitude: 1.7106566813117283,
            },
            {
              id: "lm",
              tooltip: "前往铝模展区",
              type: 0, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              width: 42,
              height: 42,
              latitude: 0.03970689196472743,
              longitude: 0.4304061290172855,
            },
          ],
        },
        {
          id: "lm",
          name: "铝模支撑体系",
          image: require("../src/assets/images/vr/lm.jpg"),
          thumbnail: require("../src/assets/images/vr/thumbnail/lm.jpg"),
          defaultLat: -0.13822302773884565,
          defaultLong: 3.448774912170828,
          defaultZoomLvl: 0,
          markers: [
            {
              id: "lm-jlq",
              tooltip: "展示剪力墙铝模支撑体系",
              type: 1, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              showProductImgList: [
                require("../src/assets/images/product/lm1.jpg"),
                require("../src/assets/images/product/lm2.jpg"),
                require("../src/assets/images/product/lm3.jpg"),
                require("../src/assets/images/product/lm4.jpg"),
              ],
              width: 42,
              height: 42,
              latitude: -0.13822302773884565,
              longitude: 3.448774912170828,
            },
          ],
        },
        {
          id: "bgl1",
          name: "办公楼1楼",
          image: require("../src/assets/images/vr/bgl1l.jpg"),
          thumbnail: require("../src/assets/images/vr/thumbnail/bgl1l.jpg"),
          defaultLat: -0.12942352227007792,
          defaultLong: 1.5693049913492783,
          defaultZoomLvl: 0,
          markers: [
            {
              id: "wlb",
              tooltip: "物流部",
              type: 1, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              width: 42,
              height: 42,
              latitude: -0.17545096410836347,
              longitude: 6.06913227050768,
            },
            {
              id: "bgl2",
              tooltip: "前往办公楼2楼",
              type: 0, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              width: 42,
              height: 42,
              latitude: -0.16602275518407272,
              longitude: 1.414278302323334,
            },
            {
              id: "zt",
              tooltip: "样品展厅",
              type: 1, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              width: 42,
              height: 42,
              latitude: -0.09016538490942216,
              longitude: 2.6309523673072466,
            },
          ],
        },
        {
          id: "bgl2",
          name: "办公楼2楼",
          image: require("../src/assets/images/vr/bgl2l.jpg"),
          thumbnail: require("../src/assets/images/vr/thumbnail/bgl2l.jpg"),
          defaultLat: -0.07785360508613892,
          defaultLong: 1.377742225704268,
          defaultZoomLvl: 0,
          markers: [
            {
              id: "zhb",
              tooltip: "综合部-办公室",
              type: 1, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              width: 42,
              height: 42,
              latitude: -0.08191273536733834,
              longitude: 6.193499666628545,
            },
            {
              id: "dzsw",
              tooltip: "前往电子商务部",
              type: 0, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              width: 42,
              height: 42,
              latitude: -0.13105186713695027,
              longitude: 1.5438434493090842,
            },
          ],
        },
        {
          id: "dzsw",
          name: "电子商务部",
          image: require("../src/assets/images/vr/dzsw.jpg"),
          thumbnail: require("../src/assets/images/vr/thumbnail/dzsw.jpg"),
          defaultLat: -0.05696389194284457,
          defaultLong: 1.5594935720001324,
          defaultZoomLvl: 0,
          markers: [
            {
              id: "wmb",
              tooltip: "电子商务-外贸部",
              type: 1, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              width: 42,
              height: 42,
              latitude: -0.11589532390581048,
              longitude: 0.21491021247378492,
            },
            {
              id: "nmb",
              tooltip: "电子商务-内贸部",
              type: 1, //0=跳转，1=弹窗
              image: require("../src/assets/images/icon/pin-blue.png"),
              width: 42,
              height: 42,
              latitude: -0.01793905948564034,
              longitude: 2.4472054084610906,
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.selectedVR = this.vr[0];
    this.init();
  },
  methods: {
    init() {
      if (this.viewer) {
        try {
          this.viewer.destroy();
        } catch (e) {
          const v = document.querySelector("#vr");
          v.removeChild(v.childNodes[0]);
        }
      }

      this.viewer = new Viewer({
        container: document.querySelector("#vr"),
        navbar: [],
        panorama: this.selectedVR.image,
        caption: "兴民伟业全景浏览",
        loadingTxt: "加载中...",
        defaultLat: this.selectedVR.defaultLat,
        defaultLong: this.selectedVR.defaultLong,
        defaultZoomLvl: this.selectedVR.defaultZoomLvl,
        size: {
          width: "100vw",
          height: "100vh",
        },
        plugins: [
          [
            MarkersPlugin,
            {
              markers: this.selectedVR.markers,
            },
          ],
        ],
      });

      this.markersPlugin = this.viewer.getPlugin(MarkersPlugin);
      this.markersPlugin.__onMouseEnter = function () {};
      this.markersPlugin.__onMouseLeave = function () {};
      this.markersPlugin.toggleAllTooltips();
      this.markersPlugin.on("select-marker", (e, marker) => {
        if (marker.config.type == 0) {
          if (
            this.vr.some((element) => {
              if (marker.config.id == element.id) {
                this.selectedVR = element;
                return true;
              }
            })
          ) {
            this.init();
          }
        } else if (marker.config.type == 1) {
          if (marker.config.showProductImgList) {
            this.markerImgList = marker.config.showProductImgList;
            this.isShowMarkerImg = true;
          }
        }
      });
      // this.viewer.on("click", (e, data) => {
      //   console.log("点击事件对象:", e);
      //   console.log("点击事件数据data:", data);
      // });
    },
    arrow_click(type) {
      if (type === "pre") {
        this.$refs.tc.scrollLeft -= 100;
      } else if (type === "next") {
        this.$refs.tc.scrollLeft += 100;
      }
    },
    ti_click(svr) {
      this.selectedVR = svr;
      this.init();
    },
    closeMarkerImg() {
      this.isShowMarkerImg = false;
    },
  },
};
</script>

<style>
#app {
  width: 100% !important;
  height: 100% !important;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
}
#logo {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 999;
  background: rgba(61, 61, 61, 0.6);
  color: white;
  padding-left: 20px;
  padding-right: 20px;
}
#logo a {
  color: white;
}
#ts {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  z-index: 90;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 80px;
  background: rgba(61, 61, 61, 1);
  -webkit-transition: bottom ease-in-out 0.1s;
  transition: bottom ease-in-out 0.1s;
}
#ts i {
  height: 80px;
  line-height: 80px;
  font-size: 30px;
  position: absolute;
  cursor: pointer;
}
#ts i:hover {
  color: white;
}
.tc {
  top: 0px;
  bottom: 0px;
  left: 30px;
  right: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 0px;
  overflow: hidden;
  position: absolute;
}
.to {
  height: 100%;
  overflow: visible;
  white-space: nowrap;
  position: absolute;
}
.active img {
  opacity: 1 !important;
}
.ti {
  height: 100%;
  position: relative;
  cursor: pointer;
}
.ti img {
  height: 100%;
  opacity: 0.3;
}
.ti img:hover {
  opacity: 1;
}
.ti span {
  position: absolute;
  left: 0px;
  bottom: 0px;
  padding: 2px;
  line-height: 20px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/App.vue